import type { RouteRecordRaw } from 'vue-router'

const sessionRoutes: RouteRecordRaw[] = [
  {
    path: 'sessions',
    name: 'Sessions',
    component: () => import('@/views/Sessions.vue'),
    meta: { title: '会话分析' },
  },
]

export default sessionRoutes
